import React from 'react';
import Modal from 'react-bootstrap/Modal';

import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

function VerifyAddressModal({ onClose }) {
  return (
    <>
      <Modal
        show
        onHide={onClose}
      >
        <Modal.Header>
          <h3>Verify Your Shipping Address</h3>
        </Modal.Header>
        <Modal.Body>
          <div className="col alert alert-info">Please verify that the shipping address for your order is correct. If you need to make changes, click the &quot;edit&quot; button next to the address.</div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-right">
            <Button
              variant="secondary"
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

VerifyAddressModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default VerifyAddressModal;
